import { render, staticRenderFns } from "./descmodal.vue?vue&type=template&id=6ab73593&scoped=true"
import script from "./descmodal.vue?vue&type=script&lang=js"
export * from "./descmodal.vue?vue&type=script&lang=js"
import style0 from "./descmodal.vue?vue&type=style&index=0&id=6ab73593&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab73593",
  null
  
)

export default component.exports